const doc = [({"en":({"js":({"classSteps":({"select":({"choose_class_step":"Choose class step"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;